"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Languages = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _components = require("../../components");

var _hooks = require("../../hooks");

var _languagesModule = _interopRequireDefault(require("./languages.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Languages = function Languages() {
  var _useLocale = (0, _hooks.useLocale)(),
      currentLocale = _useLocale.locale,
      locales = _useLocale.locales,
      defaultLocale = _useLocale.defaultLocale;

  return locales.length > 1 ? /*#__PURE__*/_react.default.createElement("div", {
    className: _languagesModule.default.wrapper
  }, locales.map(function (locale) {
    var path = locale !== defaultLocale ? "/".concat(locale) : "/";
    var className = locale === currentLocale ? "".concat(_languagesModule.default.item, " ").concat(_languagesModule.default.active) : _languagesModule.default.item;
    return /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
      key: locale,
      to: path,
      hrefLang: locale,
      className: className
    }, /*#__PURE__*/_react.default.createElement(_components.Text, {
      size: "sm",
      transform: "uppercase",
      wrapper: "span"
    }, locale));
  })) : null;
};

exports.Languages = Languages;